"use client"

import {useEffect} from "react";
import {usePathname} from "next/navigation"
import {reverseTranslateSegments, translateSegments} from "../../../i18n/translateHelpers";
const MijnMkgSubMenuClient = ({lang}) => {

    const pathname = usePathname();
    const isActive = (path) =>{
        const canonicalPath = reverseTranslateSegments(path, lang);
        const translated  = translateSegments(canonicalPath, lang)
        return pathname.includes(translated)
    }

    useEffect(() => {
        const submenu = document.getElementsByClassName("submenu");
        for (let i = 0; i < submenu.length; i++) {
            submenu[i].classList.remove("menuListItemActive")
        }
        let element;
        if (isActive('/mijn-mkg/dashboard')) {
            element = document.getElementById("subMenuDashboard");
        } else if (isActive('/mijn-mkg/mijn-gegevens')) {
            element = document.getElementById("subMenuMijnGegevens");
        } else if (isActive('/mijn-mkg/bedrijfsdoelen')) {
            element = document.getElementById("subMenuBedrijfsdoelen");
        } else if (isActive('/mijn-mkg/academy')) {
            element = document.getElementById("subMenuAcademy");
        } else if (isActive('/mijn-mkg/activiteiten')) {
            element = document.getElementById("subMenuActiviteiten");
        } else if (isActive('/mijn-mkg/support')) {
            element = document.getElementById("subMenuSupport");
        } else if (isActive('/mijn-mkg/uren')) {
            element = document.getElementById("subMenuUren");
        } else if (isActive('/mijn-mkg/beheer')) {
            element = document.getElementById("subMenuBeheer");
        }
        element?.classList?.add("menuListItemActive");
    }, [pathname, isActive]);

    return null;
}

export default MijnMkgSubMenuClient